module.exports = __webpack_public_path__ + "public/files/img/logo.7b849216.png";